import PaymentStatus from "@/enum/PaymentStatus";
import UnlockBy from "@/enum/UnlockBy";
import { money, paymentAlerts } from "@/helpers/paymentAlerts";

const MINUTES_WITHOUT_CONSUMPTION = 5;
// Acima desse percentual de bateria o carro reduz a potência naturalmente, então não é considerado problema
export const LOW_POWER_RATIO = 0.2;
const LOW_POWER_MAX_PERCENT = 80;
const MINUTES_SLOW_START = 3;
// Usado quando o carregador não tem tolerância de ociosidade configurada
const DEFAULT_IDLE_TOLERANCE = 30;
// Não usa minutesCharger porque ele vem zerado em sessões que entregaram energia
const MIN_HISTORY_CONSUMPTION = 0.1;

// Alertas de uma sessão em andamento (charger-dashboard)
export function sessionAlerts(session) {
    const { status, power, maximumPower, percent, minutesConnected, minutesCharger, consumption } = session;

    const online = session.charger.data ? session.charger.data.online == 1 : false;
    const idleTolerance = session.charger.idleTolerance || DEFAULT_IDLE_TOLERANCE;
    // Mesma regra do cálculo de ociosidade do backend (paymentCalculator)
    const idleMinutes = minutesCharger > 0 ? minutesConnected - minutesCharger : 0;

    const alerts = {
        error: !!session.errorSession,
        offline: !online,
        withoutConsumption: minutesConnected > MINUTES_WITHOUT_CONSUMPTION && !(consumption > 0),
        slowStart: status == "Preparing" && minutesConnected >= MINUTES_SLOW_START,
        idle: status != "Charging" && idleMinutes > idleTolerance,
        lowPower: status == "Charging" && maximumPower > 0 && !(percent != null && percent >= LOW_POWER_MAX_PERCENT) && power < maximumPower * LOW_POWER_RATIO,
    };

    return { ...alerts, any: Object.values(alerts).some(Boolean), online, idleMinutes, idleTolerance };
}

// Carregamento finalizado sem entregar energia (charge-history-dashboard)
export function historyFailed(item) {
    return !item.car || !(item.car.consumption >= MIN_HISTORY_CONSUMPTION);
}

export function isPaid(item) {
    return item.unlockBy == UnlockBy.PAY || !!item.idPayment;
}

// Alertas do pagamento de uma sessão paga em andamento, a API manda o resumo do pagamento em "payment"
export function sessionPaymentAlerts(session) {
    if (!isPaid(session)) return [];
    const payment = session.payment;
    if (!payment) return [{ key: "paymentNotFound", text: "Sessão paga sem pagamento vinculado", critical: true }];

    // O erro da sessão já tem alerta próprio na tela
    const alerts = paymentAlerts({ ...payment, carChargeData: session, chargerHistory: null }).filter((a) => a.key != "sessionError");
    const add = (key, text, critical = false) => alerts.push({ key, text, critical });

    // Com a sessão ainda ativa, erro na operadora não é só cartão recusado
    alerts.forEach((a) => {
        if (a.key == "operatorError") a.critical = true;
    });
    if (payment.status == PaymentStatus.FINISH || PaymentStatus.isReturned(payment.status)) {
        add("paymentClosed", `Pagamento já ${payment.status == PaymentStatus.FINISH ? "finalizado" : "devolvido"} com a sessão em andamento`, true);
    }
    if (payment.status == PaymentStatus.WAIT) {
        add("paymentWaiting", "Pagamento aguardando confirmação da operadora");
    }

    // Valor parcial calculado pela API com a mesma regra da cobrança (consumo + ociosidade + desbloqueio)
    const config = payment.config;
    const paid = Number(payment.value) || 0;
    const partialValue = session.partialValue;
    if (config && config.pricePolicy == "PAYMENT_PER_CONSUMPTION" && partialValue && paid > 0) {
        if (partialValue.total >= paid) add("paymentExhausted", `Valor parcial (${money(partialValue.total)}) já atingiu o valor pago (${money(paid)})`);
    }

    return alerts;
}

// Alertas do pagamento de um carregamento finalizado
export function historyPaymentAlerts(item) {
    if (!isPaid(item)) return [];
    if (!item.payment) return [{ key: "paymentNotFound", text: "Pagamento vinculado não encontrado", critical: true }];

    const history = { status: item.status, counter: item.counter, paymentValue: item.paymentValue, consumption: item.car ? item.car.consumption : null };
    return paymentAlerts({ ...item.payment, chargerHistory: history, carChargeData: null });
}
